import React from "react";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import CustomWindow from "./CustomWindow";
import SpinerLoading from "./SpinerLoading";
import { GameContext } from "../context/GameContext";
import { useRouter } from "next/navigation";
import Link from "next/link";

const GameModal = () => {
  const { user, setIsClosed } = useContext(AppContext);
  const {
    selectedGame,
    setSelectedGame,
    startGame,
    isIframeVisible,
    setIsIframeVisible,
    gameUrl,
    gameLoader,
  } = useContext(GameContext);

  const router = useRouter();

  const close = () => {
    setSelectedGame(null);
    setIsIframeVisible(false);
    Tawk_API.showWidget();
    document.body.style.overflow = "auto";
    //router.push("/");
    router.back();
  };

  const logIn = () => {
    setIsClosed(false);
    close();
  };

  return !isIframeVisible ? (
    <div
      id="MainContModal"
      className={`NoSelect ${selectedGame ? "" : "Close"}`}
    >
      <div id="ContModal">
        <h1 id="MaintTitleModal">{selectedGame?.displayName}</h1>

        <div className="RowColums">
          <div className="Colums CImgGame">
            <img src={selectedGame?.gameImageUrl} alt="" />
          </div>
          <div
            className="Colums"
            style={{ textAlign: "initial" }}
            dangerouslySetInnerHTML={{ __html: selectedGame?.description }}
          ></div>
        </div>

        <div className="RowColums">
          {user ? (
            <div className="Colums">
              <button
                className="BtnsModal"
                type="button"
                id="BtnUserPlayNow"
                onClick={startGame}
              >
                {!gameLoader ? "PLAY NOW!" : <SpinerLoading />}
              </button>
            </div>
          ) : (
            <div className="RowColums">
              <div className="Colums">
                <button
                  className="BtnsModal"
                  type="button"
                  id="BtnUserPlayNow"
                  onClick={startGame}
                >
                  {!gameLoader ? "Play for fun!" : <SpinerLoading />}
                </button>
              </div>
              <div className="Colums">
                <button
                  className="BtnsModal"
                  type="button"
                  id="BtnUserPlayNow"
                  onClick={logIn}
                >
                  Login
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div id="BtnClose_ModalForm" onClick={close}></div>
    </div>
  ) : (
    <CustomWindow
      iframeUrl={gameUrl}
      isIframeVisible={isIframeVisible}
      setIsIframeVisible={setIsIframeVisible}
      setSelectedGame={setSelectedGame}
    />
  );
};

export default GameModal;
